export const baseUrl = "https://api.bazargani-naderii.ir";
// export const baseUrl = "http://192.168.10.24:8001";
// export const baseUrl = "https://api.mrkala-shop.ir";